import { useNavigate, useParams } from "react-router-dom";
import {
  encodeAndStoreData,
  getdataAndDecodeStoreData,
} from "../config/encodelocalstorage";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

const ListmenuTopic = () => {
  const { topic } = useParams();
  let cookies = new Cookies();

  const navigat = useNavigate();

  const [objectMajorOperation, setObjectMajorOperation] = useState(() => {
    if (localStorage.getItem("dataMajor")) {
      return getdataAndDecodeStoreData("dataMajor");
    } else {
      return [];
    }
  });

  const [objectMinorOperation, setObjectMinorOperation] = useState(() => {
    if (localStorage.getItem("dataMinor")) {
      return getdataAndDecodeStoreData("dataMinor");
    } else {
      return [];
    }
  });

  const [objectInvestigation, setObjectInvestigation] = useState(() => {
    if (localStorage.getItem("dataInvest")) {
      return getdataAndDecodeStoreData("dataInvest");
    } else {
      return [];
    }
  });

  const [objectLaserprocedure, setObjectLaserprocedure] = useState(() => {
    if (localStorage.getItem("dataLaser")) {
      return getdataAndDecodeStoreData("dataLaser");
    } else {
      return [];
    }
  });

  const docGetid = (id) => {
    return document.getElementById(id);
  };

  function handlesetAnewDATAmajor(mode, data) {
    let arr = [];
    let datalocal = (key) => {
      return getdataAndDecodeStoreData(key);
    };

    switch (mode) {
      case "dataMajor":
        data.map((data) => {
          if (datalocal(data.topic)) {
            let objReqnew = {
              topic: data.topic,
              status: data.status,
              status_point: data.status_point,
              req: datalocal(data.topic).length,
            };
            arr.push(objReqnew);
          } else {
            arr.push(data);
          }
        });
        arr.sort((a, b) => b.req - a.req);
        setObjectMajorOperation(arr);
        encodeAndStoreData("dataMajor", arr);
        break;
      case "dataMinor":
        data.map((data) => {
          if (datalocal(data.topic)) {
            let objReqnew = {
              topic: data.topic,
              status: data.status,
              status_point: data.status_point,
              req: datalocal(data.topic).length,
            };
            arr.push(objReqnew);
          } else {
            arr.push(data);
          }
        });
        setObjectMinorOperation(arr);
        encodeAndStoreData("dataMinor", arr);
        break;
      case "dataInvest":
        data.map((data) => {
          if (datalocal(data.topic)) {
            let obj = {
              topic: data.topic,
              status: data.status,
              status_point: data.status_point,
              req: datalocal(data.topic).length,
            };
            arr.push(obj);
          } else {
            arr.push(data);
          }
        });
        setObjectInvestigation(arr);
        encodeAndStoreData("dataInvest", arr);
        break;
      case "dataLaser":
        data.map((data) => {
          if (datalocal(data.topic)) {
            let obj = {
              topic: data.topic,
              status: data.status,
              status_point: data.status_point,
              req: datalocal(data.topic).length,
            };
            arr.push(obj);
          } else {
            arr.push(data);
          }
        });
        setObjectLaserprocedure(arr);
        encodeAndStoreData("dataLaser", arr);
        break;
    }
  }

  function tonavigatpath(namemenu) {
    let linkname = namemenu.split("/").reverse().join("-");
    navigat(`/logbook/${topic}/${linkname}`);
  }

  function animationclickcardmenu(id, menu) {
    docGetid(id).style.animation = "fillLoadingInfomenu 0.35s linear normal";
    setTimeout(() => {
      tonavigatpath(menu);
    }, 350);
  }

  function showElemetTopic(mode, status, point) {
    let thisPoint = parseInt(point);
    switch (mode) {
      case "colorStatus":
        if (status === "DOP" && thisPoint === 1) {
          return { backgroundColor: "#C5D6BA" };
        } else if (status === "DOP" && thisPoint === 0) {
          return { backgroundColor: "#e0e0e0" };
        }
        if (status === "EPA") {
          if (thisPoint >= 4) {
            return { backgroundColor: "#C5D6BA" };
          } else if (thisPoint >= 1) {
            return { backgroundColor: "#F5EED8" };
          } else if (thisPoint === 0) {
            return { backgroundColor: "#e0e0e0" };
          }
        }
        break;

      case "showStatus":
        if (status === "DOP") {
          if (thisPoint === 0) {
            return `${status} ✗`;
          } else if (thisPoint === 1) {
            // return `${status}`;
            return `${status} ✓`;
          }
        } else if (status === "EPA") {
          return `${status} ${thisPoint}`;
        } else {
          return "";
        }
        break;
    }
  }

  // console.log(":|...>", objectMinorOperation[0].topic.slice(0, 16));

  function handleshowmenuTopic(topic) {
    switch (topic) {
      case "major operation":
        return objectMajorOperation.map((ele, key) => {
          return (
            <div
              key={key}
              className="card-content-resident"
              onClick={() => {
                // console.log("นี้นายคลิกนี้นา B1 !!!!");
                animationclickcardmenu(
                  `loadingmenuClick-${key}`,
                  `${ele.topic}`
                );
              }}
            >
              <div className="showinfocard-resident">
                <div className="text-cardcontent-listmenuTopic">
                  <div
                    className="loading-menu-resident"
                    id={`loadingmenuClick-${key}`}
                  ></div>
                  <div className="info-1">
                    <div className="snapscoll-info1">
                      <span className="text-menu">{`${ele.topic}`}</span>
                    </div>
                  </div>
                  <div className="info-2">
                    <span className="text-status">{`${
                      ele.status === "normal" ? "" : "status "
                    }`}</span>
                    <div className="this-aboxinfo-center">
                      <span
                        className="show-status"
                        style={showElemetTopic(
                          "colorStatus",
                          ele.status,
                          ele.status_point
                        )}
                      >{`${showElemetTopic(
                        "showStatus",
                        ele.status,
                        ele.status_point
                      )}`}</span>
                    </div>
                  </div>
                  <div className="info-3">
                    <span className="text-status">{`req`}</span>
                    <div className="this-aboxinfo-center">
                      <span className="show-requirement">{`${ele.req}`}</span>
                    </div>
                  </div>
                  <div className="info-4">
                    <i className="bi-chevron-right iconright-grid"></i>
                  </div>
                </div>
              </div>
            </div>
          );
        });
      case "minor operation":
        return objectMinorOperation.map((ele, key) => {
          return (
            <div
              key={key}
              className="card-content-resident"
              onClick={() => {
                // console.log("นี้นายคลิกนี้นา B1 !!!!");
                animationclickcardmenu(
                  `loadingmenuClick-${key}`,
                  `${ele.topic}`
                );
              }}
            >
              <div className="showinfocard-resident">
                <div className="text-cardcontent-listmenuTopic">
                  <div
                    className="loading-menu-resident"
                    id={`loadingmenuClick-${key}`}
                  ></div>
                  <div className="info-1">
                    <div className="snapscoll-info1">
                      <span className="text-menu">{`${ele.topic}`}</span>
                    </div>
                  </div>
                  <div className="info-2">
                    <span className="text-status">{`${
                      ele.status === "normal" ? "" : "status "
                    }`}</span>
                    <div className="this-aboxinfo-center">
                      <span
                        className="show-status"
                        style={showElemetTopic(
                          "colorStatus",
                          ele.status,
                          ele.status_point
                        )}
                      >{`${showElemetTopic(
                        "showStatus",
                        ele.status,
                        ele.status_point
                      )}`}</span>
                    </div>
                  </div>
                  <div className="info-3">
                    <span className="text-status">{`req`}</span>
                    <div className="this-aboxinfo-center">
                      <span className="show-requirement">{`${ele.req}`}</span>
                    </div>
                  </div>
                  <div className="info-4">
                    <i className="bi-chevron-compact-right iconright-grid"></i>
                  </div>
                </div>
              </div>
            </div>
          );
        });
      case "investigation":
        return objectInvestigation.map((ele, key) => {
          return (
            <div
              key={key}
              className="card-content-resident"
              onClick={() => {
                // console.log("นี้นายคลิกนี้นา B1 !!!!");
                animationclickcardmenu(
                  `loadingmenuClick-${key}`,
                  `${ele.topic}`
                );
              }}
            >
              <div className="showinfocard-resident">
                <div className="text-cardcontent-listmenuTopic">
                  <div
                    className="loading-menu-resident"
                    id={`loadingmenuClick-${key}`}
                  ></div>
                  <div className="info-1">
                    <div className="snapscoll-info1">
                      <span className="text-menu">{`${ele.topic}`}</span>
                    </div>
                  </div>
                  <div className="info-2">
                    <span className="text-status">{`${
                      ele.status === "normal" ? "" : "status "
                    }`}</span>
                    <div className="this-aboxinfo-center">
                      <span
                        className="show-status"
                        style={showElemetTopic(
                          "colorStatus",
                          ele.status,
                          ele.status_point
                        )}
                      >{`${showElemetTopic(
                        "showStatus",
                        ele.status,
                        ele.status_point
                      )}`}</span>
                    </div>
                  </div>
                  <div className="info-3">
                    <span className="text-status">{`req`}</span>
                    <div className="this-aboxinfo-center">
                      <span className="show-requirement">{`${ele.req}`}</span>
                    </div>
                  </div>
                  <div className="info-4">
                    <i className="bi-chevron-compact-right iconright-grid"></i>
                  </div>
                </div>
              </div>
            </div>
          );
        });
      case "laser procedure":
        return objectLaserprocedure.map((ele, key) => {
          return (
            <div
              key={key}
              className="card-content-resident"
              onClick={() => {
                // console.log("นี้นายคลิกนี้นา B1 !!!!");
                animationclickcardmenu(
                  `loadingmenuClick-${key}`,
                  `${ele.topic}`
                );
              }}
            >
              <div className="showinfocard-resident">
                <div className="text-cardcontent-listmenuTopic">
                  <div
                    className="loading-menu-resident"
                    id={`loadingmenuClick-${key}`}
                  ></div>
                  <div className="info-1">
                    <div className="snapscoll-info1">
                      <span className="text-menu">{`${ele.topic}`}</span>
                    </div>
                  </div>
                  <div className="info-2">
                    <span className="text-status">{`${
                      ele.status === "normal" ? "" : "status "
                    }`}</span>
                    <div className="this-aboxinfo-center">
                      <span
                        className="show-status"
                        style={showElemetTopic(
                          "colorStatus",
                          ele.status,
                          ele.status_point
                        )}
                      >{`${showElemetTopic(
                        "showStatus",
                        ele.status,
                        ele.status_point
                      )}`}</span>
                    </div>
                  </div>
                  <div className="info-3">
                    <span className="text-status">{`req`}</span>
                    <div className="this-aboxinfo-center">
                      <span className="show-requirement">{`${ele.req}`}</span>
                    </div>
                  </div>
                  <div className="info-4">
                    <i className="bi-chevron-compact-right iconright-grid"></i>
                  </div>
                </div>
              </div>
            </div>
          );
        });
    }
  }

  useEffect(() => {
    handlesetAnewDATAmajor("dataMajor", objectMajorOperation);
    handlesetAnewDATAmajor("dataMinor", objectMinorOperation);
    handlesetAnewDATAmajor("dataInvest", objectInvestigation);
    handlesetAnewDATAmajor("dataLaser", objectLaserprocedure);
  }, []);

  return (
    <div className="body-listmenuTopic">
      <div className="nav-listmenuTopic">
        <div className="title-listmenuTopic">
          <div
            className="boxtitle-iconleft"
            onClick={() => {
              navigat("/resident_home");
            }}
          >
            <div className="actionbox-circle" id="actionCircle"></div>
            <i className="title-iconleft bi-arrow-left-circle"></i>
          </div>
          <div className="boxtitle-textTopic">
            <span>{`${topic}`}</span>
          </div>
        </div>
      </div>
      <div className="contentbody-listmenuTopic">
        {handleshowmenuTopic(topic)}
      </div>
      <div className="footer-residenthome">
        <div className="box-relative"></div>
        <div className="box-relative"></div>
        <div className="box-relative"></div>
        <div className="box-relative">
          <i
            className="icon-footer-nav bi-box-arrow-left"
            onClick={() => {
              Swal.fire({
                title: "ออกจากระบบ!",
                text: "ต้องการออกจากระบบ ใช่ หรือ ไม่ ?",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                icon: "warning",
              }).then((res) => {
                if (res.isConfirmed) {
                  navigat("/");
                  localStorage.removeItem("filterWork");
                  localStorage.clear();
                  cookies.remove("tokenEstimate", {
                    path: "/",
                  });
                }
              });
            }}
          ></i>
        </div>
      </div>
    </div>
  );
};
export default ListmenuTopic;
